import React from 'react';
import styled from 'styled-components';
import { string,node } from 'prop-types';
import {AccentColor,OnAccentColor,Grey300,DisableColor,Secondary800,DarkAccentColor,ShadowColor} from '../../Colors';

const ExtendedButton = styled.button`
    text-decoration: none;
    border: 1px solid ${AccentColor};
    text-transform: none;
    background-color : ${AccentColor};
    border-radius : 5px;
    box-shadow:3px 3px 3px ${ShadowColor};
    color : ${OnAccentColor};
    padding : 0.5rem 1rem 0.5rem 1rem;
    &:focus{
        outline : 0;
        background-color : ${Secondary800};
        border: 1px solid ${Secondary800};
    }
    &:hover{
        background-color : ${DarkAccentColor};
        border: 1px solid ${DarkAccentColor};
    }
    &:disabled{
        background-color : ${Grey300};
        color : ${DisableColor};
        border: none;
    }
`;

const FloatingActionButton = ({children,...props}) => (
	<ExtendedButton {...props}>
		{children}
	</ExtendedButton>);

FloatingActionButton.propTypes = {
	color: string,
	fontSize: string,
	children: node,
};

export default FloatingActionButton;